import {Component} from '@angular/core';

@Component({
    selector: 'app-president-note',

    templateUrl: './president-note.component.html',
    styleUrl: './president-note.component.css'
})
export class PresidentNoteComponent {

}
